import styled from 'styled-components';
import v from 'scss/v';

export default styled.div`
  text-transform: uppercase;
  color: ${v('$uppercase-title-color')};
  font-size: 1rem;
  margin: 0.5rem 0;
`;
